<div class="lines" [style.width]="(hours.length * 60 * unit + 1)+ 'px'">
    <sc-flex [stretchContent]="true" [fitHeight]="true">
        <ng-container *ngFor="let hour of hours">
            <div class="line"></div>
            <div class="label-spacer" [style.min-width]="((60 * unit) -1) + 'px'"> </div>
        </ng-container>
        <div class="line"></div>
    </sc-flex>
</div>